import { FaFilePdf, FaIdCard } from "react-icons/fa";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import Title from "../../Title/Title";
import Search from "../../Search/Search";

interface Decision {
  accountNumber: string;
  decisionNumber: number;
  decisionSubject: string;
  decisionDate: string;
}

export default function All_Decisions() {
  const decisions: Decision[] = [
    {
      accountNumber: "215254",
      decisionNumber: 125,
      decisionSubject: "موضوع القرار",
      decisionDate: "7/7/2024",
    },
  ];

  return (
    <>
      <Row>
        <Col>
          <Title title={"عرض جميع القرارات"} />
        </Col>
      </Row>

      <Row>
        <Col lg={11} className="flex justify-center">
          <Search
            placeholder="رقم القرار"
            className="!w-[80%] border-2 border-[#efc5e6]"
          />
        </Col>
      </Row>

      <Row>
        <Col lg={10} md={4} className="mx-auto">
          <table className="w-full bg-slate-100  max-lg:w-[850px] mx-auto my-5 text-center rounded-2xl overflow-hidden ">
            <thead className=" text-black bg-[#efc5e6] h-[70px] font-bold text-base border border-white">
              <tr>
                <td>رقم الحساب </td>
                <td> رقم القرار </td>
                <td> موضوع القرار </td>
                <td> تاريخ القرار </td>
                <td> ملف القرار</td>
              </tr>
            </thead>

            <tbody className="h-[70px]">
              {decisions.map((decision, index) => (
                <tr key={index} className="border-2 border-white">
                  <td>{decision.accountNumber}</td>
                  <td>{decision.decisionNumber}</td>
                  <td>{decision.decisionSubject}</td>
                  <td>{decision.decisionDate}</td>
                  <td>
                    <div className="flex justify-evenly">
                      <div
                        id="info-emp"
                        className="flex justify-center cursor-pointer"
                      >
                        <FaFilePdf size={20} className="text-[#c433a4]" />
                        <h1 className="font-bold underline">تحميل</h1>
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Col>
      </Row>
    </>
  );
}
